import { ReactNode } from 'react';

import { IconExclamationTriangleFilled } from '@iwoca/icons';
import { Flex } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

type TCreditAgreementNoticeProps = {
    hasReadToEnd: boolean;
    showReadToEndError: boolean;
    isSignError: boolean;
};

export const CreditAgreementNotice = ({
    hasReadToEnd,
    showReadToEndError,
    isSignError
}: TCreditAgreementNoticeProps) => {
    if (isSignError) {
        return (
            <Notice isError>
                <FormattedMessage
                    id="_.funding_requirements_v2.credit_agreement.sign_error"
                    defaultMessage="We were unable to complete the signing documents process. Your account manager will be in contact soon, or give us a call."
                />
            </Notice>
        );
    }

    if (hasReadToEnd) {
        return null;
    }

    if (showReadToEndError) {
        return (
            <Notice isError>
                <FormattedMessage
                    id="_.funding_requirements_v2.credit_agreement.read_to_end_error"
                    defaultMessage="Please read the entire document to continue."
                />
            </Notice>
        );
    }

    return (
        <Notice isError={false}>
            <FormattedMessage
                id="_.funding_requirements_v2.credit_agreement.read_to_end"
                defaultMessage="Read the entire document to continue."
            />
        </Notice>
    );
};

const Notice = ({
    isError,
    children
}: {
    isError: boolean;
    children: ReactNode;
}) => (
    // ORION-113-GAP token: no surface or stroke for the notice colours (secondary-95/secondary-80, core-95/core-90)
    <Flex
        role={isError ? 'alert' : undefined}
        padding="micro"
        radius="micro"
        align="start"
        gap="tight"
        className={`border text-s font-bold text-primary-10 ${isError ? 'border-core-90 bg-core-95' : 'border-secondary-80 bg-secondary-95'}`}
    >
        <IconExclamationTriangleFilled
            className={`text-l ${isError ? 'text-core-40' : 'text-primary-10'}`}
        />
        <Flex.Item grow>
            <p className="m-0">{children}</p>
        </Flex.Item>
    </Flex>
);
